import { z } from 'zod';
import { pageInfo, viewDateValue } from '../../crew/schema/filters.js';
import { shippingClaimList } from '../../crew/schema/shippingClaim/shippingClaim.js';
import { ClaimReasonEnum, ClaimResolutionMethodEnum, ClaimStatusEnum, } from '../../enums/gsp.js';
import { enumToZodLiteralUnion, helperSchema } from '../../zodExtensions.js';
const listRequest = z.object({
    // a term searches OpenSearch across the platform instead of listing; the other filters don't apply
    searchTerm: helperSchema.optionalizedString,
    // a start date keeps every query inside an index range of `created_on`
    createdOn: viewDateValue.refine((value) => value.kind === 'preset' || value.range.start !== null, 'A custom date range needs a start date'),
    statuses: z.array(enumToZodLiteralUnion(ClaimStatusEnum)).min(1).optional(),
    claimReasons: z
        .array(enumToZodLiteralUnion(ClaimReasonEnum))
        .min(1)
        .optional(),
    resolutionMethods: z
        .array(enumToZodLiteralUnion(ClaimResolutionMethodEnum))
        .min(1)
        .optional(),
    orderBy: z.enum(['asc', 'desc']),
    cursor: z
        .object({ id: z.number(), direction: z.enum(['next', 'prev']) })
        .nullable(),
});
export const commandShippingClaim = {
    listRequest,
    listResponse: z.object({ data: shippingClaimList, pageInfo }),
};
//# sourceMappingURL=shippingClaim.js.map